<template>
  <transition name="loader-fade">
    <div v-if="showLoadingIndicator" :class="[classes]">
      <!-- {{ fallbackText }} -->
    </div>
  </transition>
</template>

<script>
  import LoadingDelayMixin from 'Mixins/LoadingDelayMixin'

  export default {
    mixins: [LoadingDelayMixin],
    computed: {
      classes () {
        const baseClass = 'ks-spinner'
        let classes = baseClass

        if (this.dark) {
          classes = `${classes} ${baseClass}--dark`
        }

        return classes
      },
    },
    props: {
      dark: {
        type: Boolean,
        default: true,
      },
      fallbackText: {
        type: String,
        default: 'Loading...',
      },
    },
  }
</script>

<style lang="scss" scoped>
  .loader-fade-enter-active, .loader-fade-leave-active {
    transition: opacity .5s;
  }

  .loader-fade-enter, .loader-fade-leave-to {
    opacity: 0;
  }
</style>
